<app-hc-home *ngIf="page === 'start'"></app-hc-home>

<div class="container-fluid position-relative process_content_container h-100" *ngIf="page !== 'start'">
  <div class="row h-100">

    <div class="col-sm-12 col-lg-6 col-xl-5 offset-xl-1 " [ngClass]="{'pt-4': isMobile, 'd-flex flex-column': page == 'informations' && !isLogged}">
      <app-process-navbar [links]="links" *ngIf="(page === 'informations' || page === 'payment'|| page === 'confirmation') && !hasForcePage" (newPage)="page = $event"></app-process-navbar>
      <!--   FORMULAIRE, PAYMENT, ATTESTATION DISPLAY   -->
      <div class="position-relative" [ngClass]="{'h-100': page == 'post-payment', 'flex-grow-1': page == 'informations' && !isLogged}">
        <app-hc-component-form *ngIf="page === 'informations'" [isEdit]="hasForcePage" (hasEdit)="forcePage($event)"></app-hc-component-form>
        <app-hc-component-confirm *ngIf="page === 'confirmation'"></app-hc-component-confirm>
        <app-hc-component-payment *ngIf="page === 'payment'" [promoCode]="promocode ? promocode.name : null" [price]="price"></app-hc-component-payment>
        <app-hc-component-post-payment *ngIf="page === 'post-payment'" (isEditTriggered)="forcePage($event)"></app-hc-component-post-payment>
        <app-hc-component-expired *ngIf="page == 'expired' && certificate" [date]="certificate.created_at"></app-hc-component-expired>

        <!--   PENDING, REFUS, REMBOURSEMENT OK     -->
        <div class="hc-pp-container d-flex flex-column" *ngIf="page === 'Pending-refund' || page === 'refunded' || page === 'not-refunded'">
          <div class="flex-grow-1 d-flex align-items-center justify-content-center mb-5" *ngIf="isLoading">
            <div class="spinner-border text-primary"></div>
          </div>
          <div *ngIf="!isLoading">
            <h1 class="title_4 txt-darkGray mb-5">{{ text.title | translate }}</h1>
            <h6 class="title_2 mt-5" *ngIf="text.subtitle"> {{ text['subtitle'] | translate }} </h6>
            <p class="text_3 my-2" [innerHTML]="text.text | translate"></p>

            <div class="position-sticky bg-white py-3 pb-lg-0 bottom_sticky d-flex gap-16">
              <button type="button" class="btn btn-lf-secondary flex-grow-1" (click)="userAction(text['btn1'])" *ngIf="text['btn1']">
                <span class="material-icons-outlined me-1 va-sub font-20">{{ text['btn1'] }}</span>
                {{ (text['btn1'] === 'close' ? 'COMMON.CANCEL' : 'HEADER.DASHBOARD') | translate }}
              </button>
              <button type="submit" class="btn btn-primary flex-grow-1 fw-bold" (click)="userAction(text['btn2'])">
                <span class="material-icons-round me-1 va-sub font-20">{{ text['btn2'] }}</span>
                {{ (text['btn2'] === 'domain' ? 'PROCESSES.ACCOMMODATION.SEE_HOUSING' : 'HEADER.BTN_HOVER_BACK_DASHBOARD') | translate }}
              </button>
            </div>
            <app-faq-accordion class="mt-3" [faqFields]="faqFields" [firstExpanded]="true"></app-faq-accordion>
          </div>
        </div>

        <!--    RE UPLOAD DE DOCUMENT    -->
        <div class="hc-pp-container d-flex flex-column" *ngIf="page === 'Pending-document'">

          <div class="flex-grow-1 d-flex align-items-center justify-content-center mb-5" *ngIf="isLoading">
            <div class="spinner-border text-primary"></div>
          </div>

          <div *ngIf="!isLoading">
            <h1 class="title_4 txt-darkGray mb-5">{{ 'PROCESSES.HOUSING_CERTIFICATE.DOC_PENDING.TITLE'| translate }} </h1>
            <h6 class="title_2"> {{ text.title | translate }} {{ text.reason ? text.reason : '' }}  </h6>
            <p class="text_3 mb-5"> {{ text['subtitle'] | translate}} </p>

            <span class="label" [ngClass]="{'text-danger' : isFormSubmitted && docForm.controls.VISA_REFUSED.errors}">
             {{ "COMMON.USER.VISA_REFUSED" | translate }}
            </span>
            <div *ngIf="isFormSubmitted && docForm.controls.VISA_REFUSED.errors" class="text-danger minitext_2">
              {{ "COMMON.IS_REQUIRED" | translate }}
            </div>
            <app-upload-file (onDelete)="onFileDelete($event)" (onUpload)="onFileUpload($event)" class="w-100 mt-1"
              [documentType]="'VISA_REFUSED'" [mode]="'single'"></app-upload-file>

            <div class="position-sticky mt-3 bg-white py-3 pb-lg-0 bottom_sticky d-flex gap-16">
              <button type="submit" class="btn btn-primary flex-grow-1 fw-bold" (click)="sendDocument()">
                <span class="material-icons-round me-1 va-sub font-20">article</span>
                {{ 'COMMON.RESERVATION_DOCUMENT.CONFIRM' | translate }}
              </button>
            </div>
            <app-faq-accordion class="mt-3" [faqFields]="faqFields"></app-faq-accordion>
          </div>

        </div>

      </div>
    </div>

    <!-------------------------------  RIGHT PART  ------------------------------->
    <div class="col-sm-12 col-lg-5 offset-lg-1 col-xl-4 mt-4 mt-sm-0" [ngClass]="page === 'post-payment' ? 'marginMobile':''">
      <div class="d-flex flex-column sticky-top hc_sticky">
        <h5 class="mb-2 txt-darkGray font-21 fw-bold" *ngIf="userState !='Not-refunded' && page !='post-payment'">
          {{ (page !== 'post-payment' ? 'PROCESSES.HOUSING_CERTIFICATE.RIGHT_BOX_TITLE' : 'PROCESSES.HOUSING_CERTIFICATE.POST_PAYMENT.RIGHT_TITLE') | translate }}
        </h5>
        <p class=" mb-4 semiBold " *ngIf="userState !='Not-refunded' && page != 'post-payment'">
          {{  (page !== 'post-payment' ? 'PROCESSES.HOUSING_CERTIFICATE.RIGHT_BOX_TEXT_1' : 'PROCESSES.HOUSING_CERTIFICATE.POST_PAYMENT.RIGHT_TEXT_1') | translate }}
        </p>

        <div class="mb-3 position-relative  br-16 w-100 px-3 py-4 flex-column d-flex align-items-center justify-content-center position-relative " [ngClass]="promocode ? 'custom':'service_img'">
          <img src="../../../../assets/img/services/housing_certificate_icon.svg" alt="" *ngIf="!promocode">
          <h5 class="mb-2 txt-darkGray font-21 fw-bold" *ngIf="userState !='Not-refunded' && page == 'post-payment'">
            {{ (page !== 'post-payment' ? 'PROCESSES.HOUSING_CERTIFICATE.RIGHT_BOX_TITLE' : 'PROCESSES.HOUSING_CERTIFICATE.POST_PAYMENT.RIGHT_TITLE') | translate }}
          </h5>
          <p class=" mb-4 semiBold heading" *ngIf="userState !='Not-refunded' && page == 'post-payment'">
            {{  (page !== 'post-payment' ? 'PROCESSES.HOUSING_CERTIFICATE.RIGHT_BOX_TEXT_1' : 'PROCESSES.HOUSING_CERTIFICATE.POST_PAYMENT.RIGHT_TEXT_1') | translate }}
          </p>
          <span class="textBlue font-trueno-bold font-34 pointer" *ngIf="promocode" [cdkCopyToClipboard]="promocode.code"
            ngbPopover="{{ 'COMMON.COPIED' | translate }}" placement="right">
            {{ promocode.code }}
            <mat-icon class="copy-icon ms-2">filter_none</mat-icon>
          </span>
          <div class=" pos mt-4 mx-auto t-center semiBold fst-italic font-12 w-75" *ngIf="promocode">{{ 'PROCESSES.HOUSING_CERTIFICATE.POST_PAYMENT.PROMO_CODE' | translate }}</div>
        </div>

        <h6 class="fw-bold font-16 mediumGray" *ngIf="page !== 'post-payment'">{{'PROCESSES.HOUSING_CERTIFICATE.RIGHT_BOX_SUBTITLE' | translate }}</h6>
        <p class=" mb-4" *ngIf="page !== 'post-payment'">{{ 'PROCESSES.HOUSING_CERTIFICATE.RIGHT_BOX_TEXT_2' | translate }}</p>
        <!--    TROUVE TON LOGEMENT BTN    -->
        <div class="row findBtns" *ngIf="page === 'post-payment'">
          <button class="btn first border-primary fw-bold py-3 text-primary border-2 d-none d-lg-block mb-2" (click)="goTo('list')">
            {{ 'LANDING_PAGE.SECTION_2_BLOC_1_BUTTON' | translate }}
          </button>
          <button class="btn border-primary fw-bold py-3 text-primary border-2 d-none d-lg-block" (click)="goTo('visa')">
            {{ 'HOUSING_CERTIFICATE.GO_TO_VISA' | translate }}
          </button>
        </div>

        <!--    EN SAVOIR PLUS    -->
        <div class="mt-auto">
          <app-code-promo-input *ngIf="page === 'payment'"
            informationKey="PROCESSES.HOUSING_CERTIFICATE.PRICE_TITLE" [itemPrice]="199" (priceAfterPromoCode)="applyPromoCode($event)"></app-code-promo-input>
          <div class="lf-primary-bg br-16 py-3 px-4 overflow-hidden mt-2 txt-darkGray" *ngIf="page !== 'post-payment'">
            <h5 class="lf-font fw-bold mb-3 font-18">
              <span class="material-icons-outlined me-1 fw-bold v-middle">help</span>
              {{ 'PROCESSES.HOUSING_CERTIFICATE.RIGHT_BOX_TEXT_3' | translate }}
            </h5>
            <p class="fw-normal">{{ 'PROCESSES.HOUSING_CERTIFICATE.RIGHT_BOX_TEXT_4' | translate }}</p>
          </div>

        </div>

        <!--       DEMANDER UN REMBOURSEMENT       -->
        <div class="mt-auto d-block d-md-flex flex-wrap" *ngIf="page === 'post-payment' && !isUsedCode && userState !='Not-refunded' && promocode">
          <div class="mb-2 p-0 p-md-2 p-lg-0">
            <h6 class="fw-bold font-16 mediumGray">{{'PROCESSES.HOUSING_CERTIFICATE.POST_PAYMENT.RIGHT_SUBTITLE_2' | translate }}</h6>
            <p class="mediumGray" *ngIf="!canRefund">{{'PROCESSES.HOUSING_CERTIFICATE.POST_PAYMENT.RIGHT_TEXT_3' | translate }}</p>
            <p class="mediumGray" *ngIf="canRefund">{{'PROCESSES.HOUSING_CERTIFICATE.POST_PAYMENT.REFUND_ALLOWED' | translate }}</p>
          </div>

          <mat-form-field *ngIf="!canRefund && !refundError">
            <mat-label>{{ 'PROCESSES.HOUSING_CERTIFICATE.POST_PAYMENT.VISA_REFUSAL_TITLE' | translate }}</mat-label>
            <mat-select [formControl]="refundFormControl" multiple>
              <mat-option *ngFor="let reason of [1,2,3,4,5,6,7]" [value]="reason">
                <span class="d-flex justify-content-between">
                  {{ 'PROCESSES.HOUSING_CERTIFICATE.POST_PAYMENT.VISA_REFUSAL_TEXT_' + reason | translate}}
                  <lf-icon class="ps-2" name="greenCheck" height="12px" width="12px" fillColor="#3f51b5" *ngIf="refundFormControl.value.includes(reason)"></lf-icon>
                </span>
              </mat-option>
            </mat-select>
          </mat-form-field>
          <div class="font-12 mb-3" *ngIf="refundError" [innerHTML]="'PROCESSES.HOUSING_CERTIFICATE.POST_PAYMENT.VISA_REFUND_REQUEST_UNAVAILABLE' | translate"></div>

          <!--   upload justificatif       -->
          <ng-container *ngIf="canRefund">
            <div class="label" [ngClass]="{'text-danger' : isFormSubmitted && docForm.controls.VISA_REFUSED.errors}">
              {{ "COMMON.USER.VISA_REFUSED" | translate }}
              <div *ngIf="isFormSubmitted && docForm.controls.VISA_REFUSED.errors" class="font-12">
                <span *ngIf="docForm.controls.VISA_REFUSED.errors.required">{{ "COMMON.IS_REQUIRED" | translate }}</span>
                <span *ngIf="docForm.controls.VISA_REFUSED.errors.code_used">{{ 'PROCESSES.HOUSING_CERTIFICATE.POST_PAYMENT.VISA_REFUND_REQUEST_CODE_USED' | translate }}</span>
              </div>
            </div>

            <app-upload-file (onDelete)="onFileDelete($event)" (onUpload)="onFileUpload($event)" class="w-100 mt-1 mb-2" [ngClass]="{'mb-3': !isFormSubmitted || (isFormSubmitted && docForm.valid)}"
              [documentType]="'VISA_REFUSED'" [mode]="'single'"></app-upload-file>
          </ng-container>

          <div class="w-100 d-flex flex-row gap-16 mt-1">
            <button class="btn btn-black-border txt-darkGray bg-white fw-bold py-3 flex-grow-1" (click)="refund()" [disabled]="refundError">
              {{ 'COMMON.ASK_REFUND' | translate }}
            </button>
          </div>

        </div>
      </div>
    </div>

  </div>
</div>

